import React from 'react';
import { motion } from 'framer-motion';
import { homeScrollItem, homeScrollViewport } from '../../utils/homeScrollMotion';
import styles from './ServicesContent.module.css';

const HERO_IMAGES = {
  primary: {
    src: '/images/banner1 (1).jpeg',
    alt: 'Greeneri B2B paper services from Meerut',
  },
  secondary: {
    src: '/images/banner1 (2).jpeg',
    alt: 'Greeneri warehouse and dispatch operations',
  },
};

const ServicesContent = () => (
  <section className={`${styles.hero} home-bg-linen`} aria-labelledby="services-page-title">
    <div className={styles.bgDecor} aria-hidden="true">
      <span className={styles.orbGreen} />
      <span className={styles.orbOrange} />
      <span className={styles.mesh} />
    </div>

    <motion.div
      className={styles.inner}
      variants={homeScrollItem}
      initial="hidden"
      animate="visible"
      viewport={homeScrollViewport}
    >
      <div className={styles.grid}>
        <div className={styles.copy}>
          <span className={styles.badge}>What we offer</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>B2B from Meerut</span>
            <h1 id="services-page-title" className={styles.title}>
              Our <span className={styles.titleAccent}>B2B Services</span>
            </h1>
          </div>

          <p className={styles.kicker}>
            Bulk reels, custom specs, batch-wise QC and Pan-India dispatch
          </p>

          <div className={styles.bodyCopy}>
            <p className={styles.body}>
              Everything your converting line needs from our Meerut facility — scheduled
              bulk supply, line-matched packaging specs, factory-floor quality checks and
              coordinated logistics across India.
            </p>
            <p className={styles.body}>
              Whether you run cup forming, food wrap converting or packaging lines, Greeneri
              plans production and dispatch around your consumption — not the other way around.
              Same GSM, width and coating spec batch after batch.
            </p>
            <p className={styles.body}>
              Explore bulk supply, custom packaging, quality testing and logistics support
              below — each service page covers deliverables, advantages and how we work with
              B2B buyers from quote through repeat orders.
            </p>
          </div>
        </div>

        <div className={styles.visual}>
          <div className={styles.imageStack}>
            <div className={styles.primaryFrame}>
              <img
                src={HERO_IMAGES.primary.src}
                alt={HERO_IMAGES.primary.alt}
                loading="eager"
                decoding="async"
              />
            </div>
            <div className={styles.secondaryFrame}>
              <img
                src={HERO_IMAGES.secondary.src}
                alt={HERO_IMAGES.secondary.alt}
                loading="eager"
                decoding="async"
              />
            </div>
            <span className={styles.accentBar} aria-hidden="true" />
            <span className={styles.accentCorner} aria-hidden="true" />
            <div className={styles.floatingCard} aria-hidden="true">
              <strong>4</strong>
              <span>Core services</span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  </section>
);

export default ServicesContent;
